import { useEffect } from "react";
import { Link } from "react-router-dom";
import Timer from "./components/Countdown/Timer";
import Optin from "./components/Optin/Optin";
import "./WelcomePage.css";

function WelcomePage() {
  useEffect(() => {
    document.title = "Auzi Apps Studios";
  }, []);

  return (
    <div className="welcomepagemaindiv">
      <div className="welcomepagebodydiv">
        <div className="welcomepageseconddiv">
          <div className="top-right-button-container">
            <Link to="/privacy-policy" className="privacy-policy-button">
              Privacy Policy
            </Link>
          </div>
        </div>

        <div className="welomepagedetail">
          <h1 className="welcometitle">
            Welcome to Auzi Apps Studios
            <br />
            Coming Soon
          </h1>
        </div>

        <Timer />
        <Optin />
      </div>
    </div>
  );
}

export default WelcomePage;
